// `as` lets a navigation link carry button styling without ceasing to be a link:
// `<Button as={Link} to="/settings">Back</Button>` keeps middle-click and open-in-new-tab.
// `type` is meaningless on an anchor and `disabled` does not exist on one, so neither is
// emitted off the button path; `aria-disabled` plus the disabled class carries the state,
// and `pointer-events: none` on that class is what actually makes it inert.
export default function Button({
  as: Tag = "button",
  variant = "secondary",
  size,
  tone,
  icon,
  loading = false,
  className = "",
  children,
  type = "button",
  disabled = false,
  ...rest
}) {
  const isButton = Tag === "button";
  const inert = disabled || loading;

  const classes = [
    "peb-btn",
    `peb-btn--${variant}`,
    size ? `peb-btn--${size}` : "",
    // `tone` recolours the label without changing the variant's box:
    // `variant="danger"` is a filled red button, `tone="danger"` is red text.
    tone ? `peb-btn--tone-${tone}` : "",
    loading ? "peb-btn--loading" : "",
    // An anchor has no intrinsic button box, so its fixed height becomes a floor instead.
    isButton ? "" : "peb-btn--anchor",
    !isButton && inert ? "peb-btn--disabled" : "",
    className,
  ].filter(Boolean).join(" ");

  const tagProps = isButton
    ? { type, disabled: inert }
    : { "aria-disabled": inert || undefined };

  return (
    <Tag className={classes} {...tagProps} {...rest}>
      {loading && <span className="peb-btn__spinner" aria-hidden="true" />}
      {!loading && icon && <i className={`bi ${icon}`} aria-hidden="true" />}
      {children}
    </Tag>
  );
}
